import "../css/header.scss";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { IoBagOutline, IoChevronDown } from "react-icons/io5";
import { STORE_CONFIG } from "../config/store";

const corePolicies = [["Privacy", "/privacy"], ["Terms", "/terms"], ["Shipping", "/shipping"], ["Returns", "/returns"], ["FAQ", "/faq"], ["Cookie", "/cookies"], ["All policies", "/policies"]];

function Header() {
  const { cartItems } = useContext(CartContext);
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const itemCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  useEffect(() => {
    const close = (event) => !menuRef.current?.contains(event.target) && setOpen(false);
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, []);

  const toTop = () => { setOpen(false); window.scrollTo({ top: 0, behavior: "smooth" }); };

  return <header className="site-header"><div className="header-container">
    <div className="logo"><Link to="/" onClick={toTop} aria-label={`${STORE_CONFIG.brand} home`}>
      <span className="brand-mark" aria-hidden="true"><i>f</i></span><span className="brand-word">fumvella</span>
    </Link></div>
    <nav className="main-nav" aria-label="Main navigation"><ul>
      <li><Link to="/shop" onClick={toTop}>SHOP</Link></li>
      <li><Link to="/about" onClick={toTop}>ABOUT US</Link></li>
      <li><Link to="/contact" onClick={toTop}>CONTACT US</Link></li>
      <li className="more-menu" ref={menuRef}>
        <button aria-expanded={open} aria-controls="more-policy-menu" onClick={() => setOpen((value) => !value)}>MORE <IoChevronDown aria-hidden="true" /></button>
        {open && <div id="more-policy-menu" className="more-dropdown">{corePolicies.map(([label, path]) => <Link key={path} to={path} onClick={toTop}>{label}</Link>)}</div>}
      </li>
    </ul></nav>
    <div className="header-actions"><Link to="/cartpage" onClick={toTop} className="icon-btn cart-btn" aria-label={`Cart with ${itemCount} items`}><IoBagOutline /><span className="cart-count">{itemCount}</span></Link></div>
  </div></header>;
}
export default Header;
